import produce from 'immer';

import { Types as SignOutTypes } from '../signout/actions';
import { Types as ValveCalibrationsActions } from './actions';

const INITIAL_STATE = {
  loading: false,
  valveCalibration: {
    id: '',
    tender: '',
    client: '',
    seal: '',
    certificateNumber: '',
    createdAt: '',
  },
};

export default function valves(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ValveCalibrationsActions.SET_VALVE_TO_WORK_REQUEST:
      return produce(state, (draft) => {
        draft.loading = true;
      });
    case ValveCalibrationsActions.SET_VALVE_TO_WORK_SUCCESS:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.valveCalibration.id = action.payload.id;
        draft.valveCalibration.tender = action.payload.tender;
        draft.valveCalibration.client = action.payload.client;
        draft.valveCalibration.seal = action.payload.seal;
        draft.valveCalibration.createdAt = action.payload.createdAt;
      });
    case ValveCalibrationsActions.SET_VALVE_TO_WORK_FAILURE:
      return produce(state, (draft) => {
        draft.loading = false;
      });

    /**
     *
     */
    case ValveCalibrationsActions.VALVE_UPDATE_REQUEST:
      return produce(state, (draft) => {
        draft.loading = true;
      });
    case ValveCalibrationsActions.VALVE_UPDATE_SUCCESS:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.valveCalibration.certificateNumber = action.payload.certificateNumber;
      });
    case ValveCalibrationsActions.VALVE_UPDATE_FAILURE:
      return produce(state, (draft) => {
        draft.loading = false;
      });

    /**
     * SIGN OUT
     */
    case SignOutTypes.SIGN_OUT_SUCCESS:
      return INITIAL_STATE;

    default:
      return state;
  }
}
